import React from 'react'
import { Button } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { signUp } from 'actions/auth'
import PropTypes from 'prop-types'
import useFormExpanded from 'hooks/useFormExpanded'
import FirstName from 'components/Fields/FirstName'
import LastName from 'components/Fields/LastName'
import Email from 'components/Fields/Email'
import Password from 'components/Fields/Password'
import PasswordConfirmation from 'components/Fields/PasswordConfirmation'

export default function SignUpForm({ communityId, onSuccessCallback }) {
  const dispatch = useDispatch()

  const formMethods = useFormExpanded()
  const { hasErrors, handleSubmit, setFieldValidationErrors, control, watch } = formMethods
  const password = watch('password')

  function save(values) {
    dispatch(signUp({ ...values, communityId }))
      .then(() => {
        onSuccessCallback()
      })
      .catch((errorResponse) => {
        setFieldValidationErrors(errorResponse)
      })
  }

  return (
    <form>
      <FirstName fullWidth autoFocus margin='dense' control={control} />
      <LastName fullWidth margin='dense' control={control} />
      <Email fullWidth margin='dense' control={control} />
      <Password fullWidth margin='dense' control={control} />
      <PasswordConfirmation fullWidth margin='dense' control={control} password={password} />
      <Button onClick={handleSubmit(save)} disabled={hasErrors} size='large' fullWidth color='primary' variant='contained'>
        sign up
      </Button>
    </form>
  )
}

SignUpForm.propTypes = {
  communityId: PropTypes.string.isRequired,
  onSuccessCallback: PropTypes.func.isRequired
}
